export enum ConversationSortBy {
  LAST_RESPONSE_AT = 'last_response_at',
  STATUS = 'status',
}
